import logo from './../../assets/images/logo.png';

function PoweredByFinPayLogo() {
  return (
    <div className="powered-by-finpay" aria-label="Powered by FinPay">
      <span className="powered-by-text">Powered by</span>
      <img src={logo} alt="FinPay" />
    </div>
  );
}

export default PoweredByFinPayLogo;
